import { Component, OnInit, OnDestroy } from '@angular/core';
import { RolesService } from 'src/app/services/roles-service/roles.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { ActivatedRoute } from '@angular/router';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-roles-role-dashboard',
  templateUrl: './roles-role-dashboard.component.html',
  styleUrls: ['./roles-role-dashboard.component.scss']
})
export class RolesRoleDashboardComponent implements OnInit, OnDestroy {

  roleInfo;
  menuSections;
  getRoleInfoSubscription: Subscription;

  constructor(private rolesService: RolesService,
              private activatedRoute: ActivatedRoute,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getRoleInfo();
    this.getSections();
  }

  private getSections() {
    this.menuSections = this.userStorageService.getMenuSectionList();
  }

  private getRoleInfo() {
    const internalId = this.activatedRoute.snapshot.params['roleid'];
    this.getRoleInfoSubscription = this.rolesService.getRoleInfo(internalId).subscribe(
      (res) => {
        this.roleInfo = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-magic', 'roles-page.role detail', '/account/roles', [new BRoute('account-page.account', '/account'), new BRoute('roles-page.roles', '/account/roles'), new BRoute('roles-page.role detail')]));
  }

  ngOnDestroy() {
    if (this.getRoleInfoSubscription) { this.getRoleInfoSubscription.unsubscribe(); }
  }
}
